import ExportType from "@/apps/dashboard/catalog/core/domain/model/ExportType.enum";

export class ExportCsv {
  private readonly _id: string;
  private readonly _exportType: ExportType;
  private readonly _url: string | null;
  private readonly _entriesCount: number | null;
  private readonly _error: string | null;

  constructor(
    id: string,
    exportType: ExportType,
    url: string | null,
    entriesCount: number | null = null,
    error: string | null = null
  ) {
    this._id = id;
    this._exportType = exportType;
    this._url = url;
    this._entriesCount = entriesCount;
    this._error = error;
  }

  get id(): string {
    return this._id;
  }

  get exportType(): ExportType {
    return this._exportType;
  }

  get url(): string | null {
    return this._url;
  }

  get entriesCount(): number | null {
    return this._entriesCount;
  }

  get error(): string | null {
    return this._error;
  }
}
